import React, { useEffect, useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import BtnLight from "../../../../common/element/Buttons/btnLight";
import Button from "../../../../common/element/Buttons";
import BtnPrimary from "../../../../common/element/Buttons/btnPrimary";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ProviderRegisterPaymentInfo } from "../../../../actions/public/ProviderRegisterPaymentInfo";
import Steps from "../../../../common/element/Steps";
import { GetInvitedProviderChecklist } from "../../../../actions/provider-portal/registration/GetInvitedProviderChecklist";
import { GetProviderChecklistByClient } from "../../../../actions/provider-portal/registration/GetProviderChecklistByClient";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import Upload from "../../../../common/element/Upload";
import ClientInput from "../../../../common/element/Input/clientInput";
import DatePicker from "../../../../common/element/DatePicker";
import dayjs from "dayjs";
import { AddProviderDocsAndSubmit } from "../../../../actions/provider-portal/registration/AddProviderDocsAndSubmit";
import Card from "../../../../common/element/Card";
import { SignupProviderForClient } from "../../../../actions/public/SignupProviderForClient";
import moment from "moment/moment";
import ThreeDotLoader from "../../../../common/element/ButtonLoader/ThreeDotLoader";

const InviteClientPayment = (props) => {
  // props?.onDialogClose if step == 0 then show new popup
  
  const { ProviderContactData } = useSelector((state) => state);
  const { ProviderRegisterFinalData } = useSelector((state) => state);
  const { SignUpData } = useSelector((state) => state);
  const [invoiceData, setInvoiceData] = useState(null);
  const [token, setToken] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const { invite_provider_id } = useParams(); // Gets '183' from the URL
  const dateGap = 0;
  const dispatch = useDispatch();
  const [step, setStep] = useState(0);
  const [checkError, setCheckError] = useState(false);
  const [firstStep, secondStep] = useState(false);
  const [docData, SetDocData] = useState([]);
  const [workerDocData, SetworkerDocData] = useState([]);
  const [open, setOpen] = useState(0);
  const [complianceData, setComplianceData] = useState({
    client_org_id: "",
    provider_org_id: "",
    docsData: [],
    provider_trading_name: "",
    abn_nzbn: "",
    sub_invoice_id: "",
  });
  const [agree, setAgree] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [checkPayment, setCheckPayment] = useState(true);

  const [paymentData, setPaymentData] = useState(null);


  useEffect(() => {
    localStorage.setItem('countpaymentpage', step);
    return () => {
      // if (props?.onDialogClose) {
      //   props.onDialogClose(step, ProviderContactData?.is_client_pay_licence);
      // }
    };
  }, [step]);
  
  const onChange = (nextStep) => {
    if (nextStep < 0) {
      setStep(0);
    } else {
      setStep(nextStep);
    }
  };

  const onPrevious = () => onChange(step - 1);

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };

  function Icon({ id, open }) {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.68296 1.97217V18.7722M1.28296 10.3722H18.083"
          stroke="#5786CC"
          stroke-width="2.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }

  const handleDeletePDF = (event, field, index) => {
    let newValue;
    if (field == "doc") {
      newValue = event[0];
      setComplianceData((prevalue) => {
        return {
          ...prevalue,
          ["doc" + index]: "",
        };
      });
    }
  };

  // Handle form
  const handleForm = (event, field, index, custom_field, customIndex) => {
    let newValue;
    if (field == "allow_expiry") {
      newValue = event;
    } else if (field == "doc") {
      newValue = event[0];
      setComplianceData((prevalue) => {
        return {
          ...prevalue,
          ["doc" + index]: newValue,
        };
      });
      return;
    } else {
      newValue = event.target.value;
    }
    setComplianceData((prevValue) => {
      // Create a new array with the updated field
      const updatedDocsData = prevValue.docsData.map((item, idx) => {
        if (idx === index) {
          // Return a new object with updated field
          if (field == "doctype_fields_data") {
            return {
              ...item,
              doctype_fields_data: item.doctype_fields_data.map(
                (fieldItem, fieldIdx) => {
                  if (fieldIdx === customIndex) {
                    // Update the specific field within doctype_fields_data
                    return {
                      ...fieldItem,
                      [custom_field]: newValue,
                    };
                  }
                  // Return unchanged fieldItem for all other indices
                  return fieldItem;
                }
              ),
            };
          } else {
            return {
              ...item,
              [field]: newValue,
            };
          }
        }
        // Return unchanged item for all other indices
        return item;
      });

      // Return the updated state
      return {
        ...prevValue,
        docsData: updatedDocsData,
      };
    });
  };

  // Min Date
  const minDate = dayjs(new Date())
    .subtract(dateGap, "day")
    .startOf("day")
    .toDate();

  const combinedProvCheckDoc = docData?.flatMap((item) => item.inviteProviComp);
  const combinedWorkerCheckDoc = workerDocData?.flatMap(
    (item) => item.inviteProviComp
  );

  const onNext = async (step) => {
    if (ProviderContactData?.is_client_pay_licence) {
      if (step == 1) {
        props.onDialogClose();
        return;
      }

      const allFieldsNonEmpty = complianceData.docsData.map((doc) => {
        let allNonEmpty = true;

        Object.keys(doc).forEach((key) => {
          if (typeof doc[key] === "string" && doc[key] === "") {
            allNonEmpty = false;
          } else if (Array.isArray(doc[key])) {
            doc[key].forEach((item) => {
              Object.keys(item).forEach((innerKey) => {
                if (item[innerKey] === "") {
                  allNonEmpty = false;
                }
              });
            });
          }
        });

        return allNonEmpty;
      });
      const hasNonEmptyValues = (data) => {
        return Object.keys(data).some(
          (key) =>
            key !== "client_org_id" &&
            key !== "provider_org_id" &&
            key !== "docsData" &&
            data[key] !== ""
        );
      };

      const result = hasNonEmptyValues(complianceData);
      const checkValue = allFieldsNonEmpty.some((value) => value === false)
        ? false
        : true;
      if (combinedProvCheckDoc.length == 0) {
        onChange(step + 1);
      } else {
        if (checkValue && result) {
          //apply loader
          setIsProcessing(true);
          dispatch(AddProviderDocsAndSubmit(complianceData, token)).then(
            (response) => {
              if (response.success) {
                onChange(step + 1);
              }
            }
          ).finally(() => {
            setIsProcessing(false);
          })
          setCheckError(false);
        } else {
          setCheckError(true);
        }
      }
    } else {
      if (step == 0) {
        
        if (checkPayment) {
          setIsProcessing(true);
          if (!stripe || !elements) {
            return;
          }
          const cardElement = elements.getElement(CardElement);
          const { error, token } = await stripe.createToken(cardElement);
          if (error) {
            setError(error.message);
            console.error(error);
            setIsProcessing(false);
          } else {
            let payload = {
              ...props?.formData,
              payment_info: JSON.stringify({
                ...paymentData,
                cardToken: token.id,
              }),
              provider_type_id: paymentData?.provider_type_id,
              is_client_pay_licence: ProviderContactData?.is_client_pay_licence,
            };

            if (paymentData?.provider_type_id || paymentData?.amount) {
              dispatch(SignupProviderForClient(payload)).then((resp) => {
                if (resp.success) {
                  setComplianceData({
                    client_org_id: resp?.data?.client_org_id,
                    provider_org_id: resp?.data?.provider_org_id,
                    docsData: [],
                    provider_trading_name: resp?.data?.provider_trading_name,
                    abn_nzbn: resp?.data?.abn_nzbn,
                  });
                  setToken(resp?.data?.token);
                  checkListData(
                    resp?.data?.client_org_id,
                    resp?.data?.provider_org_id,
                    resp?.data?.sub_invoice_id
                  );
                  setIsProcessing(false);
                  // setStep(1);
                  setCheckPayment(false);
                  // set in localStorage payment is successful
                   localStorage.setItem('countpaymentpage', "paymentSuccess");
                } else {
                  setIsProcessing(false);
                }
              }).finally(() => {
                setIsProcessing(false);
              })
            }
          }
        } else {
          setStep(1);
        }
      }
      if (step == 2) {
        props.onDialogClose();
        return;
      }
      if (step == 1) {
        const allFieldsNonEmpty = complianceData.docsData.map((doc) => {
          let allNonEmpty = true;
          Object.keys(doc).forEach((key) => {
            if (typeof doc[key] === "string" && doc[key] === "") {
              allNonEmpty = false;
            } else if (Array.isArray(doc[key])) {
              doc[key].forEach((item) => {
                Object.keys(item).forEach((innerKey) => {
                  if (item[innerKey] === "") {
                    allNonEmpty = false;
                  }
                });
              });
            }
          });

          return allNonEmpty;
        });
        const hasNonEmptyValues = (data) => {
          return Object.keys(data).some(
            (key) =>
              key !== "client_org_id" &&
              key !== "provider_org_id" &&
              key !== "docsData" &&
              data[key] !== ""
          );
        };

        const result = hasNonEmptyValues(complianceData);
        const checkValue = allFieldsNonEmpty.some((value) => value === false)
          ? false
          : true;
        if (combinedProvCheckDoc.length == 0) {
          onChange(step + 1);
        } else {
          const checkExpiryDate = complianceData?.docsData
          const isAllExpiryValid = !checkExpiryDate.some(item =>
            item.hasOwnProperty("allow_expiry") &&
            (item.allow_expiry === null || item.allow_expiry === undefined || item.allow_expiry === "")
          );
          const newPayload = complianceData;
          if (checkValue && result && isAllExpiryValid) {
            newPayload?.docsData?.forEach(doc => {
              if (doc.hasOwnProperty('allow_expiry') && doc.allow_expiry) {
                doc.expiry_date = doc.allow_expiry;
              }
            });
            //apply loader 
            setIsProcessing(true);
            dispatch(AddProviderDocsAndSubmit(newPayload, token)).then(
              (response) => {
                if (response.success) {
                  onChange(step + 1);
                }
              }
            ).finally(() => {
              setIsProcessing(false);
            })
            setCheckError(false);
          } else {
            setCheckError(true);
          }
        }
      }
    }
  };

  // const handleSubmit = async (event) => {
  //   event.preventDefault();

  //   if (!stripe || !elements) {
  //     return;
  //   }

  //   const cardElement = elements.getElement(CardElement);
  //   const { error, token } = await stripe.createToken(cardElement);

  //   if (error) {
  //     setError(error.message);
  //     console.error(error);
  //   } else {
  //     // let payload = {
  //     //   ...data,
  //     //   payment_info: JSON.stringify({ ...paymentData, cardToken: token.id }),
  //     //   provider_type_id: paymentData?.provider_type_id,
  //     // };
  //     // dispatch(SignupProviderForClient(payload)).then((resp) => {
  //     //   if (resp.success) {
  //     //     setDialogAddOpen(true);
  //     //   }
  //     // });
  //   }
  // };

  const { tempEngagementDoc, tempMsaDoc, ...updatedData } =
    ProviderRegisterFinalData;
  const downloadInvoice = () => {
    // invoiceData.xero_invoice_pdf
    if (invoiceData && invoiceData.xero_invoice_pdf) {
      const link = document.createElement("a");
      link.href = invoiceData.xero_invoice_pdf;
      link.download = "invoice.pdf"; // Set the file name
      link.target = "_blank"; // Open in new tab for security if on another domain
      link.click();
    } else {
      console.error("No PDF URL found in invoice data");
    }
  };

  useEffect(() => {
    if (ProviderContactData?.is_client_pay_licence) {
      setToken(props?.GetProviderChecklistByClient?.token);
      let client_org_id = props?.GetProviderChecklistByClient?.client_org_id;
      let provider_org_id =
        props?.GetProviderChecklistByClient?.provider_org_id;
      let provider_trading_name =
        props?.GetProviderChecklistByClient?.provider_trading_name;
      let abn_nzbn = props?.GetProviderChecklistByClient?.abn_nzbn;
      setComplianceData({
        client_org_id: client_org_id,
        provider_org_id: provider_org_id,
        docsData: [],
        provider_trading_name: provider_trading_name,
        abn_nzbn: abn_nzbn,
      });
      setAgree(true);
      checkListData(client_org_id, provider_org_id, "");
    } else {
      let payload = {
        registrationType: "inviteByClient",
        provider_type_id:
          props?.formData?.provider_regist_data?.provider_type_id || "",
        invite_provider_id: invite_provider_id || props?.providerTypeIdSNC,
        isProviderExist: false,
        provider_org_id: "",
      };
      dispatch(ProviderRegisterPaymentInfo(payload)).then((response) => {
        if (response) {
          setPaymentData(response?.data);
        }
      });
    }
  }, []);

  const checkListData = (client_org_id, provider_org_id, sub_invoice_id) => {
    setComplianceData((prevValue) => {
      return {
        ...prevValue,
        docsData: [],
      };
    });
    dispatch(
      GetProviderChecklistByClient({
        client_org_id: client_org_id,
        provider_org_id: provider_org_id,
        sub_invoice_id: sub_invoice_id,
      })
    ).then((response) => {
      if (response.success) {
        setInvoiceData(response?.data?.invoice);
        SetDocData(
          response?.data?.inviteProvComp?.filter(
            (item) => item.check_comp_assigned_to == 1 && item
          )
        );
        SetworkerDocData(
          response?.data?.inviteProvComp?.filter(
            (item) => item.check_comp_assigned_to == 0 && item
          )
        );
        response?.data?.inviteProvComp?.flatMap(
          (doc, index) =>
            doc?.check_comp_assigned_to == 1 &&
            doc?.inviteProviComp?.map((item, innerIndex) => {
              const newObject = {};
              newObject["checklist_doc_id"] = item.checklist_doc_id;
              newObject["is_other_doc"] = item.is_other_doc;
              newObject["doc_name"] = "";
              for (const [key, value] of Object.entries(item?.document_type)) {
                if (key == "document_type_id") {
                  newObject["document_type_id"] = value;
                }
                if (key == "custom_fields" && !item.is_other_doc) {
                  newObject["doctype_fields_data"] = value?.map((key) => ({
                    [key]: "",
                  }));
                }
                if (value === true) {
                  newObject[key] = "";
                }
              }
              setComplianceData((prevValue) => {
                return {
                  ...prevValue,
                  [`doc${index + innerIndex}`]: "",
                  // [`doc${index + innerIndex}`]: "",
                  docsData: [...prevValue.docsData, newObject],
                };
              });
            })
        );
      }
    });
  };

  return (
    <React.Fragment>
      <div className="px-6">
        <Steps current={step}>
          {ProviderContactData?.is_client_pay_licence == false && (
            <Steps.Item title="Payment" />
          )}
          <Steps.Item title="Compliance checklist" />
          <Steps.Item title="Workers assignment" />
        </Steps>
      </div>

      <form>
        <div className="mt-6 add-client-form px-6">
          {ProviderContactData?.is_client_pay_licence == false && step === 0 ? (
            <React.Fragment>
              {checkPayment && (
                <div className="pl-6 pr-6">
                  <h5 className="text-blue-800 font-semibold text-2xl mb-2">
                    Payment options
                  </h5>
                  <p className="text-gray-700 mb-3">
                    This annual payment covers a license for one client and two included workers
                  </p>
                  <div>
                    <div className="w-full">
                      <form>
                        <Card className="p-7 border border-gray-200 rounded-xl">
                          <h5 className="text-blue-800 font-semibold text-2xl mb-7">
                            Payment
                          </h5>
                          <h4 className="font-bold text-gray-700 text-base mb-1">
                            Annual License Fee (ex GST)
                          </h4>
                          {/* <p className="text-gray-700 mb-7">
                            ${paymentData?.amount}
                          </p> */}
                          <p className={`flex gap-2 ${paymentData?.amount ? "text-gray-700" : "text-red-500"}`}
                          >
                            {paymentData?.amount
                              ? `$ ${(Number(paymentData?.amount)).toFixed(2)}`
                              : "We couldn’t retrieve the fee information. Please try again later."}
                          </p>
                          <h4 className="font-bold text-gray-700 text-base mb-1">
                            License Period
                          </h4>
                          <p className="text-gray-700">
                            {moment(new Date()).format("DD/MM/YYYY")} -{" "}
                            {moment(paymentData?.end_date).format("DD/MM/YYYY")}
                          </p>
                        </Card>
                        <Card className="p-7 border border-gray-200 rounded-xl mt-7">
                          <div className="bg-gray-100">
                            <div className="bg-white w-full">
                              {/* Payment Method Buttons */}
                              <h2 className="text-lg font-semibold mb-3">
                                Card Information
                              </h2>
                              <form className="space-y-4">
                                {/* Card Number */}
                                <div className="border rounded-lg p-3 focus-within:border-blue-500 transition">
                                  <CardElement
                                    options={{
                                      hidePostalCode: true,
                                      disableAutofill: true, // Prevent autofill suggestions
                                      style: {
                                        base: {
                                          fontSize: "16px",
                                          color: "#333",
                                          "::placeholder": {
                                            color: "#a0aec0",
                                          },
                                        },
                                        invalid: { color: "#e53e3e" },
                                      },
                                    }}
                                  />
                                </div>

                                {/* Checkbox */}
                                <div className="flex items-center gap-2">
                                  <input
                                    type="checkbox"
                                    id="terms"
                                    checked={agree}
                                    onChange={() => setAgree(!agree)}
                                    className="cursor-pointer"
                                  />
                                  <label
                                    htmlFor="terms"
                                    className="text-sm text-gray-600 cursor-pointer"
                                  >
                                    I understand and accept that this licensing fee is valid for 12 months
                                  </label>
                                </div>

                                {/* Submit Button */}

                                {/* Error Message */}
                                {error && (
                                  <p className="text-red-500 text-sm">
                                    {error}
                                  </p>
                                )}
                              </form>
                            </div>
                          </div>
                        </Card>
                      </form>
                    </div>
                  </div>
                </div>
              )}

              {!checkPayment && (
                <React.Fragment>
                  <div className="pl-4 pr-4">
                    <div className="mb-5 bg-gray-50 rounded-xl border border-gray-200 p-5">
                      <h3 className="mb-1 text-gray-700 font-bold text-base">
                        Payment successful
                      </h3>
                      <p className="mb-4 text-gray-700">
                        Thank you for your payment. A confirmation of this
                        transaction has been sent to your email.
                      </p>
                      <h3 className="mb-1 text-gray-700 font-bold text-base">
                        Invoice number{" "}
                      </h3>
                      <p className="mb-4 text-gray-700">
                        <p>{invoiceData?.xero_invoice_number}</p>
                      </p>
                      <Button
                        className="flex gap-1  text-blue-700 hover:text-blue-900 focus:text-blue-700"
                        onClick={downloadInvoice}
                      >
                        Download invoice{" "}
                        <svg
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.583 13.2866V14.2866C17.583 15.6868 17.583 16.3868 17.3105 16.9216C17.0708 17.392 16.6884 17.7745 16.218 18.0141C15.6832 18.2866 14.9831 18.2866 13.583 18.2866H6.58301C5.18288 18.2866 4.48281 18.2866 3.94803 18.0141C3.47763 17.7745 3.09517 17.392 2.85549 16.9216C2.58301 16.3868 2.58301 15.6868 2.58301 14.2866V13.2866M14.2497 9.11995L10.083 13.2866M10.083 13.2866L5.91634 9.11995M10.083 13.2866V3.28662"
                            stroke="#5786CC"
                            stroke-width="1.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Button>
                    </div>
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          ) : (
            ProviderContactData?.is_client_pay_licence ? step == 0 : step == 1
          ) ? (
            <div id={firstStep}>
              <div className="mb-5">
                <h4 className="text-blue-800 text-base font-bold">
                  Compliance checklist
                </h4>
                <p className="text-gray-700">
                  The Compliance checklist ensures that you meet all the
                  necessary requirements set by the client, allowing you to
                  demonstrate your compliance with their specified guidelines
                  and regulations.
                </p>
              </div>
              <div className="flex flex-col gap-5">
                {combinedProvCheckDoc?.map((item, index) => {
                  return (
                    <React.Fragment>
                      <div
                        className="flex justify-between bg-gray-50 p-5 rounded-xl border border-gray-200"
                        key={index}
                      >
                        <Accordion
                          open={open === item?.checklist_doc_id}
                          icon={
                            <Icon id={item?.checklist_doc_id} open={open} />
                          }
                        >
                          <div className="flex justify-between">
                            <h4 className="text-gray-700 font-bold ">
                              {index + 1}. {` ${item?.document_type?.doc_type_name}`}
                            </h4>
                            <div className="flex ml-auto gap-3 items-center">
                              <Button
                                className="flex  text-xs items-center text-blue-700 font-semibold gap-2"
                                onClick={() =>
                                  handleOpen(item?.checklist_doc_id)
                                }
                              >
                                Upload{" "}
                                <svg
                                  width="21"
                                  height="21"
                                  viewBox="0 0 21 21"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M17.583 3H2.58301M15.083 11.3333L10.083 6.33333M10.083 6.33333L5.08301 11.3333M10.083 6.33333V18"
                                    stroke="#5786CC"
                                    stroke-width="1.66667"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </Button>
                            </div>
                          </div>

                          <AccordionBody className="grid-cols-2 grid gap-2">
                            <div className="p-4 rounded-xl border border-gray-300 flex items-center justify-between w-full col-span-full mb-2">
                              {complianceData["doc" + index] == "" && (
                                <Upload
                                  value={""}
                                  accept={".jpg, .jpeg, .png, .gif"}
                                  showList={false}
                                  onChange={(e) => {
                                    handleForm(e, "doc", index);
                                  }}
                                  className="w-full"
                                >
                                  <div className="text-center">
                                    <div className="flex items-center justify-center flex-col cursor-pointer">
                                      {" "}
                                      <span className="flex w-9 h-9 items-center justify-center rounded-full bg-gray-200 outline outline-8 outline-gray-50 outline-offset-0">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M6.667 13.333 10 10m0 0 3.333 3.333M10 10v7.5m6.666-3.548a4.583 4.583 0 0 0-2.917-8.12.516.516 0 0 1-.444-.25 6.25 6.25 0 1 0-9.816 7.58"
                                            GetProviderChecklistByClientstroke="#475467"
                                            strokeWidth="1.667"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          ></path>
                                        </svg>
                                      </span>
                                      <span className="pt-4 cursor-pointer">
                                        <span className="text-blue-700 font-semibold mr-1 cursor-pointer">
                                          Click to upload
                                        </span>{" "}
                                        <span className="text-xs text-gray-600 cursor-pointer">
                                          {" "}
                                          or drag and drop ( max. 25mb)
                                        </span>
                                      </span>
                                    </div>
                                  </div>
                                  {/* {sizeError && (
                                      <div className="text-red-500 text-sm mt-1">
                                        {sizeError}
                                      </div>
                                    )} */}
                                </Upload>
                              )}
                              {complianceData["doc" + index] != "" && (
                                <React.Fragment>
                                  <div className="flex  gap-4">
                                    <span className="w-9 h-9 rounded-full border-4 border-blue-50 bg-blue-200 flex justify-center items-center">
                                      <img
                                        src="/assets/icons-svg/upload-pdf.svg"
                                        alt=""
                                      />
                                    </span>
                                    <div className="flex flex-col justify-center">
                                      <span className="text-gray-700 text-xs font-medium">
                                        {complianceData["doc" + index]?.name}
                                      </span>
                                    </div>
                                  </div>

                                  <button
                                    onClick={(e) => {
                                      handleDeletePDF(e, "doc", index);
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="19"
                                      viewBox="0 0 24 25"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M9 3.5h6m-12 3h18m-2 0-.701 10.52c-.105 1.578-.158 2.367-.499 2.965a3 3 0 0 1-1.298 1.215c-.62.3-1.41.3-2.993.3h-3.018c-1.582 0-2.373 0-2.993-.3A3 3 0 0 1 6.2 19.985c-.34-.598-.394-1.387-.499-2.966L5 6.5m5 4.5v5m4-5v5"
                                        stroke="#344054"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </button>
                                </React.Fragment>
                              )}
                            </div>
                            <div className="mb-5">
                              <label className="font-medium text-gray-700">
                                Document name
                              </label>
                              <div className="flex gap-2.5 mt-1">
                                <ClientInput
                                  name={"doc_name"}
                                  inputchangehandler={(e) =>
                                    handleForm(e, "doc_name", index)
                                  }
                                  className="w-full h-10 select-options"
                                />
                              </div>
                            </div>
                            {item?.document_type?.req_issuer && (
                              <div className="mb-4">
                                <label className="font-medium text-gray-700">
                                  Issuing authority
                                </label>
                                <div className="flex gap-2.5 mt-1">
                                  <ClientInput
                                    name={"req_issuer"}
                                    inputchangehandler={(e) =>
                                      handleForm(e, "req_issuer", index)
                                    }
                                    className="w-full h-10 select-options"
                                  />
                                </div>
                              </div>
                            )}

                            {item?.document_type?.req_policy_no && (
                              <div className="mb-4">
                                <label className="font-medium text-gray-700">
                                  Policy number
                                </label>
                                <div className="flex gap-2.5 mt-1">
                                  <ClientInput
                                    name={"req_policy_no"}
                                    inputchangehandler={(e) =>
                                      handleForm(e, "req_policy_no", index)
                                    }
                                    className="w-full h-10 select-options"
                                  />
                                </div>
                              </div>
                            )}
                            {item?.document_type?.req_amount_insured && (
                              <div className="mb-4">
                                <label className="font-medium text-gray-700">
                                  Amount insured
                                </label>

                                <div className="flex">
                                  <div className="w-full relative">
                                    <span className="adon_icon absolute left-2 top-10px">
                                      <svg
                                        width="16"
                                        height="17"
                                        viewBox="0 0 20 21"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M5 13.789a3.333 3.333 0 0 0 3.333 3.333h3.334a3.333 3.333 0 0 0 0-6.667H8.333a3.333 3.333 0 1 1 0-6.666h3.334A3.333 3.333 0 0 1 15 7.122m-5-5V18.79"
                                          stroke="#667085"
                                          strokeWidth="1.667"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </span>
                                    <div className="w-full">
                                      <ClientInput
                                        type={"number"}
                                        placeholder="Enter value here"
                                        name={"req_amount_insured"}
                                        inputchangehandler={(e) =>
                                          handleForm(
                                            e,
                                            "req_amount_insured",
                                            index
                                          )
                                        }
                                        className="w-full h-10 select-options pl-8"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {item?.document_type?.allow_expiry && (
                              <div className="mb-4">
                                <label className="font-medium text-gray-700">
                                  Expiry date
                                </label>
                                <div className="mt-1 w-full">
                                  <DatePicker
                                    onChange={(e) =>
                                      handleForm(e, "allow_expiry", index)
                                    }
                                    placeholder="Select expiry date"
                                    minDate={minDate}
                                  />
                                </div>
                              </div>
                            )}
                            {item?.document_type?.req_expiry_date_notes && (
                              <div className="mb-4">
                                <label className="font-medium text-gray-700">
                                  Additional info
                                </label>
                                <div className="flex gap-2.5 mt-1">
                                  <textarea
                                    name={"req_expiry_date_notes"}
                                    onChange={(e) =>
                                      handleForm(
                                        e,
                                        "req_expiry_date_notes",
                                        index
                                      )
                                    }
                                    rows={4}
                                    cols={40}
                                    placeholder="."
                                    className="moduleDescTextarea input-shadow text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline h-10"
                                  />
                                </div>
                              </div>
                            )}
                            {item?.document_type?.custom_fields &&
                              Object.values(
                                item?.document_type?.custom_fields
                              )?.map((item, customIndex) => {
                                return (
                                  <div className="mb-4" key={customIndex}>
                                    <label className="font-medium text-gray-700">
                                      {item}
                                    </label>
                                    <div className="flex gap-2.5 mt-1">
                                      {/* <input
                                          type="text"
                                          className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                                        /> */}
                                      <ClientInput
                                        name={item}
                                        inputchangehandler={(e) =>
                                          handleForm(
                                            e,
                                            "doctype_fields_data",
                                            index,
                                            item,
                                            customIndex
                                          )
                                        }
                                        className="w-full h-10 select-options"
                                      />
                                    </div>
                                  </div>
                                );
                              })}
                          </AccordionBody>
                        </Accordion>
                      </div>
                    </React.Fragment>
                  );
                })}
                {combinedProvCheckDoc.length == 0 && (
                  <div className="h-full w-full text-center mt-2 mb-2">
                    No data available
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div id={secondStep}>
              <div className="mb-5">
                <h4 className="text-blue-800 text-base font-bold">
                  Assign workers
                </h4>
                <p className="text-gray-700">
                  You will need to customise your workforce by choosing the
                  right workers to be assigned to the client. Keep in mind that
                  workers must complete the client's induction modules and
                  provide the requested documents as specified by the client.
                </p>
              </div>
              <Accordion open={open === 1}>
                <AccordionHeader
                  onClick={() => handleOpen(1)}
                  className="reset-accordian-btn"
                >
                  <div>
                    <div>
                      <h4 className="text-gray-700 font-semibold">
                        View only: Required documents
                      </h4>
                      <p>
                        This is the list of documents needed by the client for
                        worker approval. Please ensure that workers complete the
                        document submission process accurately and promptly to
                        facilitate the approval process and enable seamless
                        collaboration with the client.
                      </p>
                    </div>
                    <Button className="flex text-blue-700 font-semibold gap-2"></Button>
                  </div>
                </AccordionHeader>
                <AccordionBody className="grid-cols-2 grid gap-2">
                  <ul>
                    {combinedWorkerCheckDoc.map((item, index) => {
                      return (
                        <li key={index}>
                          <h4 className="text-gray-700 font-bold ">
                            {index + 1}. {` ${item?.document_type?.doc_type_name}`}
                          </h4>
                        </li>
                      );
                    })}
                  </ul>
                </AccordionBody>
              </Accordion>
              <div className="text-gray-700 mt-5">
                Please invite your workers in the Workers section of your
                Dashboard,
              </div>
            </div>
          )}
        </div>
        {checkError && (
          <div className="flex flex-column">
            <p className="text-xs text-red-600 mt-2 ml-5">
              {"All field's are required!"}
            </p>
          </div>
        )}
        <div className="flex dailog-footer gap-2 justify-end">
          <BtnLight
            className="w-auto px-4"
            onClick={onPrevious}
            disabled={step === 0}
          >
            Cancel
          </BtnLight>
          {/* <BtnPrimaryLight className="w-auto px-4">
            Save and continue another time
          </BtnPrimaryLight> */}
          {
            <BtnPrimary
              className="w-auto px-4"
              disabled={
                 !agree ||
                 isProcessing || (!paymentData?.amount)}
              onClick={() => onNext(step)}
              // disabled={step === 0}
              variant="solid"
            >
              {step === 0 ? (
                <span className="flex justify-center">
                  {isProcessing ? <ThreeDotLoader /> : " Continue"}
                  <img
                    src="assets/icons-svg/arrow-right.svg"
                    alt=""
                    className="ml-2"
                  />{" "}
                </span>
              ) : step === 1 ? (
                <span className="flex justify-center">
                  {ProviderContactData?.is_client_pay_licence ? (
                    isProcessing ? (
                      <ThreeDotLoader />
                    ) : (
                      "Complete"
                    )
                  ) : isProcessing ? (
                    <ThreeDotLoader />
                  ) : (
                    " Continue"
                  )}
                  <img
                    src="assets/icons-svg/arrow-right.svg"
                    alt=""
                    className="ml-2"
                  />{" "}
                </span>
              ) : (
                <span>{isProcessing ? <ThreeDotLoader /> : " Complete"}</span>
              )}
            </BtnPrimary>
          }
          {/* <BtnPrimary className="w-auto px-6" onClick={handleSubmit}>
            Confirm and pay
          </BtnPrimary> */}
        </div>
      </form>
    </React.Fragment>
  );
};

export default InviteClientPayment;
